import { IChat } from '../chat';
import { IDepartment } from '../department/interfaces';
import { IMessage } from '../message';
import { IQuickReplyJsonEncoded } from '../quickReply';
import { ITemplate } from '../templates';
import { BulkSendLog } from '../templates';
import { EventName } from './constants';
import { User } from '../user';
import { ExportEntity } from '../exports';

export interface ServerEvent<Data = any> {
    name: EventName;
    data: Data;
}

type DocDeletedEventData = {
    /** ID of deleted document */
    _id: string;
};

/** Newly created message */
export type MessageCreatedEventData<IsJSON extends boolean = true> = IMessage<IsJSON, true>;

export type MessageUpdatedEventData<IsJSON extends boolean = true> = IMessage<IsJSON, true>;

export type MessageDeletedEventData = DocDeletedEventData;

/** Newly created chat */
export type ChatCreatedEventData<IsJSON extends boolean = true> = IChat<IsJSON>;

export type ChatUpdatedEventData<IsJSON extends boolean = true> = IChat<IsJSON>;

export type ChatDeletedEventData = DocDeletedEventData;

export type ChatsBulkUpdatedEventData = undefined;

/** Newly created department */
export type DepartmentCreatedEventData = IDepartment;

export type DepartmentUpdatedEventData = IDepartment;

export type DepartmentDeletedEventData = DocDeletedEventData;

/** Newly created template */
export type TemplateCreatedEventData<IsJSON extends boolean = true> = ITemplate<IsJSON>;

export type TemplateUpdatedEventData<IsJSON extends boolean = true> = ITemplate<IsJSON>;

export type TemplateDeletedEventData = DocDeletedEventData;

export type QuickReplyCreatedEventData = IQuickReplyJsonEncoded;

export type QuickReplyUpdatedEventData = IQuickReplyJsonEncoded;

export type QuickReplyDeletedEventData = DocDeletedEventData;

export type UserStatusUpdatedEventData = {
    uid: string;
    last_changed: Date;
    /** New status that was set */
    status: User.Status;
};

export type UserCreatedEventData = User.User;


export type UserUpdatedEventData = User.User;

export type UserDeletedEventData = DocDeletedEventData;

export type SessionDeletedEventData = DocDeletedEventData;

export type BulkSendStartedEventData = {
    _id: string;
    totalClients: number;
};

export type BulkSendProgressEventData<IsJSON extends boolean = true> = BulkSendLog<IsJSON> & {
    _id: string;
};

export type EventNameDataMap<IsJSON extends boolean = true> = {
    [EventName.chat_created]: ChatCreatedEventData<IsJSON>;
    [EventName.chat_updated]: ChatUpdatedEventData<IsJSON>;
    [EventName.chat_deleted]: ChatDeletedEventData;
    [EventName.message_created]: MessageCreatedEventData<IsJSON>;
    [EventName.message_updated]: MessageUpdatedEventData<IsJSON>;
    [EventName.message_deleted]: MessageDeletedEventData;
    [EventName.chats_bulk_updated]: ChatsBulkUpdatedEventData;
    [EventName.user_status_updated]: UserStatusUpdatedEventData;
    [EventName.department_created]: DepartmentCreatedEventData;
    [EventName.department_updated]: DepartmentUpdatedEventData;
    [EventName.department_deleted]: DepartmentDeletedEventData;
    [EventName.template_created]: TemplateCreatedEventData<IsJSON>;
    [EventName.template_updated]: TemplateUpdatedEventData<IsJSON>;
    [EventName.template_deleted]: TemplateDeletedEventData;
    [EventName.quick_reply_created]: QuickReplyCreatedEventData;
    [EventName.quick_reply_updated]: QuickReplyUpdatedEventData;
    [EventName.quick_reply_deleted]: QuickReplyDeletedEventData;
    [EventName.bulk_send_started]: BulkSendStartedEventData;
    [EventName.bulk_send_progress]: BulkSendProgressEventData<IsJSON>;
    [EventName.user_created]: UserCreatedEventData;
    [EventName.user_updated]: UserUpdatedEventData;
    [EventName.user_deleted]: UserDeletedEventData;
    [EventName.session_deleted]: SessionDeletedEventData;
    [EventName.export_updated]: ExportEntity<IsJSON>;
    [EventName.export_created]: ExportEntity<IsJSON>;
    [EventName.export_deleted]: DocDeletedEventData;
};
